export const MERCHANT_HEATMAP_NOTIFICATION_MESSAGES = {
    FETCH_ERROR: 'Failed to fetch merchant heatmap data.',
    EXPORT_ERROR: 'Failed to export data.',
} as const;

export const QUICK_FILTER_OPTIONS = [
    { value: 'last_7_days', label: 'Last 7 Days' },
    { value: 'last_30_days', label: 'Last 30 Days' },
    { value: 'last_90_days', label: 'Last 90 Days' },
    { value: 'custom', label: 'Custom' },
] as const;

export const PERFORMANCE_LABELS = {
    excellent: 'Excellent',
    good: 'Good',
    needs_focus: 'Needs Focus',
} as const;

export const PERFORMANCE_COLORS = {
    excellent: { bg: '#d1fae5', text: '#065f46' },
    good: { bg: '#fef3c7', text: '#92400e' },
    needs_focus: { bg: '#fee2e2', text: '#b31b3b' },
} as const;

export const REDEMPTION_LEVEL_COLORS = {
    high: '#00c950', // >70%
    medium: '#fdb323', // 50-70%
    low: '#fb2c36', // <50%
} as const;

